module.exports = __webpack_public_path__ + "img/app2.55b9b2c7.png";